<app-spinner-loading></app-spinner-loading>
<app-nav></app-nav>
<div class="general-container" fxLayout="column" fxFlexOffset="15%" fxFlexOffset.xs="0" fxFlex="70%" fxFlex.xs="100%">
    <router-outlet></router-outlet>
</div>